
export const networkType = (network) => (network === "Flare Mainnet" ? "flr" : "sgb");
